function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import { Button } from 'reactstrap';
import PointLayerCategory from './PointLayerCategory';
import MapLayerToggle from './MapLayerToggle';
import Panel from '../../../core/Panel/Panel';
import PanelHeader from '../../../core/Panel/PanelHeader';
import PanelBody from '../../../core/Panel/PanelBody';
import usePointLayers from './usePointLayers';
import { MdRefresh } from 'react-icons/md';

var PanelLayersView = function PanelLayersView(_ref) {
  var onClose = _ref.onClose,
      props = _objectWithoutPropertiesLoose(_ref, ["onClose"]);

  var _usePointLayers = usePointLayers(),
      pointLayers = _usePointLayers.pointLayers,
      resetAll = _usePointLayers.resetAll,
      togglePointLayer = _usePointLayers.togglePointLayer,
      toggleCategoryPointLayers = _usePointLayers.toggleCategoryPointLayers;

  if (!pointLayers) return null;
  return /*#__PURE__*/React.createElement(Panel, _extends({
    className: "map-panel-slideout-layers tour-desk-8"
  }, props), /*#__PURE__*/React.createElement(PanelHeader, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("h2", {
    className: "gotham18"
  }, i18n.translate("UI_MAP_POINTS_OVERLAYS")), /*#__PURE__*/React.createElement(Button, {
    onClick: resetAll,
    color: "outlined",
    className: "knockout12"
  }, /*#__PURE__*/React.createElement(MdRefresh, null), /*#__PURE__*/React.createElement("span", null, i18n.translate('BUTTON_RESET_POINTS')))), /*#__PURE__*/React.createElement(PanelBody, null, /*#__PURE__*/React.createElement("div", {
    className: "points-group-parent"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "gotham16"
  }, i18n.translate("UI_MAP_POINTS")), /*#__PURE__*/React.createElement("div", {
    className: "gotham14 grey2 mt-4 mb-4",
    dangerouslySetInnerHTML: {
      __html: i18n.translate("UI_MAP_LAYER_1_DESC")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "layer-group"
  }, pointLayers.map(function (cat, i) {
    return /*#__PURE__*/React.createElement(PointLayerCategory, _extends({
      key: cat.id,
      defaultOpen: i === 0
    }, cat, {
      onChange: togglePointLayer,
      onChangeAll: toggleCategoryPointLayers
    }));
  }))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "map-static-layer-toggle"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "gotham16"
  }, i18n.translate("UI_MAP_LAYERS_STATIC_TITLE")), /*#__PURE__*/React.createElement("div", {
    className: "gotham14 grey2 mt-4 mb-4",
    dangerouslySetInnerHTML: {
      __html: i18n.translate("UI_MAP_LAYER_STATIC_DESC")
    }
  }), /*#__PURE__*/React.createElement(MapLayerToggle, null))));
};

export default PanelLayersView;